"use strict";export default angular.module("app.constants", [])
  .constant("GOOGLE_STATIC_MAPS_KEY", "AIzaSyBVvRYGnSTIFppjaVB_qmdi8Enl5suNW4s")
  .constant("GA_CHECKOUT_STEPS", {"entrance":1,"contactInfo":2,"shippingAddress":3,"shippingMethod":4,"paymentMethod":5,"billingAddress":6})
  .constant("PAYMENT_TYPES", [{"name":"Credit/debit card","value":"Credit Card"},{"name":"Cash","value":"Cash"},{"name":"PayPal","value":"PayPal","type":"other","imageUrl":"https://www.paypalobjects.com/webstatic/en_US/i/buttons/PP_logo_h_200x51.png"}])
  .constant("CART_LOCAL_STORAGE_KEY", "VOL_CART_ID")
  .constant("TENANT_LOCAL_STORAGE_KEY", "VOL_TENANT_ID")
  .constant("USE_NEW_CART_SERVICE_KEY", "VOL_USE_NEW_CARTS")
  .constant("DEFAULT_ERROR_MSG", "Unexpected error occurred. Please refresh and try again.")
  .constant("PAYPAL_ENV", "production")
  .constant("PAYPAL_ID", "3EEAHLVZY3RJW")
  .constant("LAUNCH_DARKLY_KEY", "57fd29f7760ce0074f27ff9b")
  .constant("BASE_API_URL", "https://api.material.com")
  .constant("PAYPAL_CLIENT_ID", "AdybeG3hNG3xDrQ0QNDw9Rbjf2KMxqoNn5vbNYhgQowqMIlsvvz1X3jOsaTWu-1TM0NnvcSsLm1bkNXA")
  .constant("BN_CODE", "Volusion_PCP");


//////////////////
// WEBPACK FOOTER
// ./src/app/constants/constants.json
// module id = 36
// module chunks = 0